import PrimaryButton from 'components/button/PrimaryButton';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import { theme } from 'utils/style/theme';
import styled from 'styled-components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InputWrappingBox from 'components/container/InputWrappingBox';
import { Checkbox, message } from 'antd';
import { handleMessage } from 'utils/helper/message';
import { useNavigate } from 'react-router-dom';
import InputStyled from 'components/InputStyled';
import Table from './Table';
import { ISupportLanguage } from 'utils/types/storyTypes';
import DatepickerStyled from 'components/DatepickerStyled';
import { charactersApis } from 'apis/characters/charactersApis';
import dateFormat from 'utils/helper/dateFormat';
import dayjs from 'dayjs';
import moment from 'moment';
import refreshPage from 'utils/helper/refreshPage';
import { check } from 'prettier';

interface IProps {
  data: any | null;
  setData: React.Dispatch<React.SetStateAction<any | null>>;
  langList: ISupportLanguage[] | null;
  setSelectedType: React.Dispatch<React.SetStateAction<string>>;
  selectedType: string;
  projectId: string | undefined;
}

export interface IVisible {
  create: boolean;
  edit: boolean;
}

const FormRightContent: React.FC<IProps> = ({
  data,
  setData,
  langList,
  setSelectedType,
  selectedType,
  projectId,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [visible, setVisible] = useState<IVisible>({
    create: false,
    edit: false,
  });

  const [modalTitle, setModalTitle] = useState<string>('');
  const [selected, setSeleteced] = useState<any>(null);

  function hasDuplicates(localizations) {
    const checkArr: string[] = [];

    if (!localizations) return false;

    localizations.forEach((item: any) => {
      if (checkArr.includes(item.lang)) {
        return true;
      } else {
        checkArr.push(item.lang);
      }
    });

    return false;
  }

  // * 프로필 정보 저장하자..
  const handleSubmit = async () => {
    if (data) {
      // Check duplicate languages
      const hasSection1Duplicate = hasDuplicates(data.section1_localizations);
      const hasSection2Duplicate = hasDuplicates(data.section2_localizations);
      const hasSection3Duplicate = hasDuplicates(data.section3_localizations);
      const hasSection4Duplicate = hasDuplicates(data.section4_localizations);
      const checkLineDuplicate = data?.lines?.map((e) => {
        if (e.localizations && e.localizations.length) {
          return hasDuplicates(e.localizations);
        }
        return false;
      });
      const hasLineDuplicate = checkLineDuplicate.every(
        (item) => item === false,
      );

      if (
        hasSection2Duplicate ||
        hasSection4Duplicate ||
        hasSection1Duplicate ||
        hasSection3Duplicate ||
        !hasLineDuplicate
      ) {
        handleMessage(message, 'error', 'You can not select same language');
      } else {
        try {
          // 저장 , 'update' 에 갱신된값이 전달된다.
          const result = await charactersApis.characterUpdate(
            projectId,
            data.id,
            data,
          );

          console.log('프로필 저장 응답받음');

          if (result.isSuccess && result.update) {
            console.log('상태 변경 : ', result.update);
            setData(result.update);
            handleMessage(message, 'success', t('message.saveSuccess'));
          } else {
            handleMessage(message, 'error', t('message.saveFail'));
          }

          // refreshPage();
        } catch (err) {
          handleMessage(message, 'error', t('message.saveFail'));
        }
      }
    }
  };
  const handleCancel = () => {
    navigate(-1);
  };

  const handleChange = (value, type) => {
    const cloneData = JSON.parse(JSON.stringify(data));
    cloneData[type] = value;
    setData(cloneData);
  };

  return (
    <>
      <InputWrappingBox>
        <Wrapper>
          <SectionWarpper>
            <div className='header'>
              <p>
                프로필 캐릭터 ID : <span>{data?.id}</span>
              </p>
            </div>
            <div>
              <p className='disabled-text'>
                {t(
                  'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.name',
                )}
                :
              </p>
              <InputStyled defaultValue={data?.speaker} disabled />
            </div>
            <CheckboxSection>
              <CheckboxWrapper>
                <p className='title'>
                  {t(
                    'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.main',
                  )}
                  :
                </p>
                <CheckboxStyled
                  checked={data?.is_main}
                  onChange={(e) => {
                    handleChange(e.target.checked, 'is_main');
                  }}
                />
              </CheckboxWrapper>
              <CheckboxWrapper>
                <p className='title'>
                  {t(
                    'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.standing',
                  )}
                  :
                </p>
                <CheckboxStyled
                  checked={data?.use_standing}
                  onChange={(e) => {
                    handleChange(e.target.checked, 'use_standing');
                  }}
                />
              </CheckboxWrapper>
              <CheckboxWrapper>
                <p className='title'>
                  {t(
                    'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.emoticon',
                  )}
                  :
                </p>
                <CheckboxStyled
                  checked={data?.use_emoticon}
                  onChange={(e) => {
                    handleChange(e.target.checked, 'use_emoticon');
                  }}
                />
              </CheckboxWrapper>
            </CheckboxSection>
            <InputSection>
              <div className='input-box'>
                <p className='text'>
                  {t(
                    'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.height',
                  )}
                </p>
                <InputStyled
                  defaultValue={data?.profile_height}
                  type='number'
                  onChange={(e) => {
                    handleChange(e.target.value, 'profile_height');
                  }}
                />
              </div>
              <div className='input-box'>
                <p className='text'>
                  {t(
                    'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.age',
                  )}
                  :
                </p>
                <InputStyled
                  defaultValue={data?.profile_age}
                  type='number'
                  onChange={(e) => {
                    handleChange(e.target.value, 'profile_age');
                  }}
                />
              </div>
              <div className='input-box'>
                <p className='text'>
                  {t(
                    'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.birthDate',
                  )}
                  :
                </p>
                <DatepickerStyled
                  value={
                    data?.profile_birth_date
                      ? dayjs(
                          moment(data?.profile_birth_date).format('YYYY-MM-DD'),
                          dateFormat,
                        )
                      : null
                  }
                  format={dateFormat}
                  onChange={(date, dateString) => {
                    const newDate = new Date(dateString);
                    const formattedDate = newDate.toISOString();
                    handleChange(formattedDate, 'profile_birth_date');
                  }}
                />
              </div>
            </InputSection>
            <div>
              <p className='middle-title'>
                {t(
                  'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.favorite',
                )}
                :
              </p>
              <Table
                data={data}
                setData={setData}
                tableData={data?.section1_localizations}
                setSelectedEl={setSeleteced}
                visible={visible}
                setVisible={setVisible}
                title='Text'
                type='section1_localizations'
                setTitleModal={setModalTitle}
                langList={langList}
                modalTitle={modalTitle}
                setSelectedType={setSelectedType}
                selectedType={selectedType}
                projectId={projectId}
                selected={selected}
              />
            </div>
            <div>
              <p className='middle-title'>
                {t(
                  'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.dislike',
                )}
                :
              </p>
              <Table
                data={data}
                setData={setData}
                tableData={data?.section2_localizations}
                setSelectedEl={setSeleteced}
                visible={visible}
                setVisible={setVisible}
                title='Text'
                type='section2_localizations'
                setTitleModal={setModalTitle}
                langList={langList}
                modalTitle={modalTitle}
                setSelectedType={setSelectedType}
                selectedType={selectedType}
                projectId={projectId}
                selected={selected}
              />
            </div>
            <div>
              <p className='middle-title'>
                {t(
                  'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.introduce',
                )}
                :
              </p>
              <Table
                data={data}
                setData={setData}
                tableData={data?.section3_localizations}
                setSelectedEl={setSeleteced}
                visible={visible}
                setVisible={setVisible}
                title='Text'
                type='section3_localizations'
                setTitleModal={setModalTitle}
                langList={langList}
                modalTitle={modalTitle}
                setSelectedType={setSelectedType}
                selectedType={selectedType}
                projectId={projectId}
                selected={selected}
              />
            </div>
            <div>
              <p className='middle-title'>
                {' '}
                {t(
                  'storyEpisodeID.storyTabMenuList.charactersContent.editProfile.etc',
                )}
              </p>
              <Table
                data={data}
                setData={setData}
                tableData={data?.section4_localizations}
                setSelectedEl={setSeleteced}
                visible={visible}
                setVisible={setVisible}
                title='Text'
                type='section4_localizations'
                setTitleModal={setModalTitle}
                langList={langList}
                modalTitle={modalTitle}
                setSelectedType={setSelectedType}
                selectedType={selectedType}
                projectId={projectId}
                selected={selected}
              />
            </div>
          </SectionWarpper>
        </Wrapper>
      </InputWrappingBox>
      <SubmitFlexBox style={{ columnGap: 12, marginTop: '24px' }}>
        <>
          <PrimaryButton
            text={'뒤로가기'}
            height='40px'
            width='151px'
            bgColor='#FFFF'
            textColor={theme.colors.dark_400}
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.gray_6}`}
            rounded='6px'
            hoverBgColor={'#FFFF'}
            activeBgColor={'#FFFF'}
            selectedBgColor={'#FFFF'}
            onClick={handleCancel}
          />
          <PrimaryButton
            text={t('updateStory.form.buttonSubmit')}
            height='40px'
            width='151px'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
          />
        </>
      </SubmitFlexBox>
    </>
  );
};

export default FormRightContent;

const Wrapper = styled.div`
  & > * + * {
    margin-top: 16px;
  }
  .middle-title {
    font-weight: ${theme.fontWeights.bold};
  }
  .title {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header p {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.bold};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_500};
  }
  .header p span {
    font-weight: ${theme.fontWeights.bold};
  }
  .fixed {
    display: flex;
    align-items: center;
    justify-content: center;
    & > * + * {
      margin-left: 10px;
    }
  }
  .condition {
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > * + * {
      margin-left: 16px;
    }
  }
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 24px;
  }
  .ant-input-disabled {
    color: ${theme.colors.dark_300};
  }
`;

const CheckboxStyled = styled(Checkbox)`
  .ant-checkbox .ant-checkbox-input {
    cursor: default;
  }
  .ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
    border: 1px solid #d9d9d9;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: 1rem;
  }
`;

const CheckboxSection = styled.div`
  display: flex;
  & > * + * {
    margin-left: 24px;
  }
`;

const InputSection = styled.div`
  display: flex;
  .input-box {
    width: 35%;
  }
  .text {
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.bold};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  & > * + * {
    margin-left: 46px;
  }
`;
